import { send } from '@avensia/excite-commercetools';

export function addAccessoryToCart({
  sku,
  accessoryToSku,
  quantity = 1,
  button_location,
}: Pick<NordicNest.Api.AddAccessoryCommand, 'sku' | 'accessoryToSku'> & {
  quantity?: number;
  button_location?: string;
}) {
  const command: NordicNest.Api.AddAccessoryCommand = {
    $type: 'AddAccessoryCommand',
    sku,
    accessoryToSku,
    quantity,
  };

  return send(command, {
    additionalProductAttributes: {
      ecommerce: { button_location, button_name: 'add_to_cart' },
    },
  });
}
